import { FieldSetsForm } from "lego-gui-lib/lib/components/Views/ShowView/FieldSetsForm";
import { inject } from "mobx-react";
import React from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import {
  CreateView,
  IndexView,
  ShowView,
  withBreadCrumbs
} from "lego-gui-lib/lib";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../common/tabContainers";
import {
  QueueConfigurationSchemaColumns,
  QueueConfigurationSchemaShowAndCreate
} from "./schema";
import { ParentRoute } from "../../core/model/parent";
import { isAllowed } from "../../common/common";
import { observer } from "mobx-react-lite";

export const QueueConfigurationViewComponent = () => {
  const match = useRouteMatch();
  const baseUrl = match.path;
  return (
    <>
      <ParentRoute
        path={baseUrl + "/:id"}
        dataSourceName={"queueConfiguration"}
      />
      <Switch>
        <Route
          exact={true}
          path={baseUrl}
          component={QueueConfigurationIndex}
        />
        <Route path={baseUrl + "/create/:id"} component={Create} />
        <Route path={baseUrl + "/create"} component={Create} />
        <Route path={baseUrl + "/:id"} component={Show} />
      </Switch>
    </>
  );
};

const injectDataSource = (comp: any) =>
  inject("queueConfiguration", "i18n", "SAN", "commons")(observer(comp));

export const QueueConfigurationIndex = injectDataSource(
  ({ queueConfiguration, i18n, SAN, ...rest }: any) => {
    const title = i18n.t("hns:queueConfig:domain", { count: 2 });
    return (
      <IndexView
        dataSource={queueConfiguration.listDataSource}
        {...rest}
        title={title}
        titleVariant={"h5"}
        toolbarButtons={{ delete: true, export: true }}
        rowButtons={{ edit: true, delete: true, copy: true, export: true }}
        columns={QueueConfigurationSchemaColumns}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ queueConfiguration, i18n, SAN, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:queueConfig:domain"
    });
    const baseUrl = match.url;
    const history = useHistory();

    return withBreadCrumbs(
      { to: baseUrl + "/create", children: title },
      <CreateView
        dataSource={queueConfiguration.oneDataSource}
        {...rest}
        Presentation={FieldSetsForm}
        title={title}
        goBack={() => history.goBack()}
        fields={QueueConfigurationSchemaShowAndCreate}
        id={match.params}
        initialValues={
          !match.params.id
            ? {
                queueSize: 5,
                queueMaxWaitTime: 600,
                queueMaxConRetries: 100,
                queueRetryPeriod: 20
              }
            : undefined
        }
      />
    );
  }
);

export const Show = injectDataSource(
  ({ queueConfiguration, i18n, match }: any) => {
    const allowed = isAllowed(queueConfiguration);
    const title = allowed
      ? i18n.t("common:edit", {
          domain: "hns:queueConfig:domain"
        })
      : i18n.t("hns:queueConfig:domain");
    const baseUrl = match.url;
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/edit", children: title },
      <ShowView
        dataSource={queueConfiguration.oneDataSource}
        title={title}
        Presentation={FieldSetsForm}
        fields={QueueConfigurationSchemaShowAndCreate}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);
